import { ArrayField, asField } from "informed";
import React, { Fragment, useState } from "react";
import classnames from "classnames";

const CheckboxGroup = asField(({ fieldState, fieldApi, ...props }) => {
  const [selectAll, setSelectAll] = useState(false);
  let { value = [] } = fieldState;
  const { setValue, setTouched } = fieldApi;

  const {
    onChange,
    onBlur,
    forwardedRef,
    field,
    icon,
    options,
    optionsNames,
    showSelectAllBtn,
    selectAllLabel,
  } = props;
  const allOptions = options.map((option) => option[optionsNames.value]);
  const handleChange = (e) => {
    if (e.target.checked) {
      value.push(e.target.value);
      setValue(value);
    } else {
      value.splice(value.indexOf(e.target.value), 1);
      setValue(value);
    }
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setValue([
        ...Array.from(
          options.map((option) => option[optionsNames.value].toString())
        ),
      ]);
      setSelectAll(true);
    } else {
      setSelectAll(false);
      setValue([]);
    }
  };
  return (
    <Fragment>
      <ArrayField field={field}>
        <div>
          {props.label && (
            <label htmlFor={field}>
              {icon && icon}
              {props.label}
              {props.required && <i style={{ color: "red" }}>*</i>}
            </label>
          )}
        </div>
        {showSelectAllBtn && (
          <div className="select-all" style={{}}>
            <input
              checked={value.length === allOptions.length}
              id={`select-all-${selectAllLabel}`}
              type="checkbox"
              onChange={(e) => {
                handleSelectAll(e);
              }}
              onBlur={(e) => {
                setTouched(true);
              }}
            />
            <label
              style={{ verticalAlign: "baseline" }}
              htmlFor={`select-all-${selectAllLabel}`}
              className="mx-2"
            >
              {selectAllLabel ? (
                selectAllLabel
              ) : (
                <>{!selectAll ? "Select All" : "Remove All"}</>
              )}
            </label>
          </div>
        )}
        <>
          <div className="checkbox-group">
            {options.map((option, index) => {
              return (
                <Fragment key={index}>
                  <div className="checkbox-input">
                    <input
                      id={option[optionsNames.label]}
                      className="mr-2"
                      type="checkbox"
                      ref={forwardedRef}
                      value={option[optionsNames.value]}
                      checked={
                        value.includes(option[optionsNames.value].toString())
                          ? true
                          : false
                      }
                      onChange={(e) => {
                        handleChange(e);
                        if (onChange) {
                          onChange(e);
                        }
                      }}
                      onBlur={(e) => {
                        setTouched(true);
                        if (onBlur) {
                          onBlur(e);
                        }
                      }}
                    />
                    <label
                      // style={{ verticalAlign: "baseline" }}
                      htmlFor={option[optionsNames.label]}
                      className={classnames({
                        "d-flex": option["additionalInfo"],
                      })}
                      // className="mx-2"
                    >
                      {option[optionsNames.label]}
                      {option.additionalInfo || null}
                    </label>
                  </div>
                </Fragment>
              );
            })}
          </div>
        </>
        {fieldState.error ? (
          <div className="invalid-field">{fieldState.error}</div>
        ) : null}
      </ArrayField>
    </Fragment>
  );
});
export default CheckboxGroup;
